import { Controller } from "@hotwired/stimulus";
import Tooltip from "bootstrap-latest/js/dist/tooltip.js";

export default class extends Controller {
  static targets = ["toggleLink", "sideFilters"];

  connect() {
    this.titleShow = this.data.get("title-show");
    this.titleHide = this.data.get("title-hide");
    this.controllerEl = this.toggleLinkTarget.parentElement;
  }

  toggleFilterSideBar(event) {
    let target = event.currentTarget;
    $(this.controllerEl).removeClass("closed");
    this.sideFiltersTarget.classList.contains("show")
      ? this.hideFilterSideBar(target)
      : this.showFilterSideBar(target);
  }

  hideFilterSideBar(target) {
    $(this.sideFiltersTarget).collapse("hide");
    target.setAttribute("aria-expanded", "false");
    this.updateTooltip(target, this.titleShow);
    $(this.controllerEl).addClass("closed");
  }

  showFilterSideBar(target) {
    $(this.sideFiltersTarget).collapse("show");
    target.setAttribute("aria-expanded", "true");
    this.updateTooltip(target, this.titleHide);
  }

  updateTooltip(target, value) {
    const tooltip = Tooltip.getInstance(target);
    tooltip.setContent({ ".tooltip-inner": value });
  }
}
